import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const pageStyles = theme => ({
  divider: {
    height: '1px',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
  },
});

const Divider = ({ classes }) => {
  return <div className={classes.divider}></div>;
};

export default withStyles(pageStyles)(Divider);
